import React from 'react';
import { useTranslation } from 'react-i18next';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';

import { NEW_CALENDAR_MODES, NEW_CALENDAR_PERIODS } from '../newCalendar.config';

export function NewCalendarToolbar({ activeMode, activePeriod, onModeChange, onPeriodChange }) {
  const { t } = useTranslation();

  const periodButtons = [
    { label: t('common-month'), value: NEW_CALENDAR_PERIODS.MONTH },
    { label: t('common-week'), value: NEW_CALENDAR_PERIODS.WEEK },
    { label: t('common-day'), value: NEW_CALENDAR_PERIODS.DAY },
  ];

  const modeButtons = [
    { ariaLabel: t('common-calendar'), icon: CalendarMonthOutlinedIcon, value: NEW_CALENDAR_MODES.CALENDAR },
    { ariaLabel: t('common-list', { defaultValue: 'List' }), icon: ViewListOutlinedIcon, value: NEW_CALENDAR_MODES.LIST },
  ];

  return (
    <div className="new-calendar-toolbar-controls">
      <div className="new-calendar-button-group" role="group" aria-label={t('calendar-period-controls', { defaultValue: 'Calendar period' })}>
        {periodButtons.map(({ label, value }) => (
          <button
            key={value}
            type="button"
            className={`new-calendar-button${activePeriod === value ? ' is-active' : ''}`}
            onClick={() => onPeriodChange(value)}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="new-calendar-button-group" role="group" aria-label={t('calendar-mode-controls', { defaultValue: 'Calendar mode' })}>
        {modeButtons.map(({ ariaLabel, icon: Icon, value }) => (
          <button
            key={value}
            type="button"
            className={`new-calendar-button new-calendar-button--icon${activeMode === value ? ' is-active' : ''}`}
            onClick={() => onModeChange(value)}
            aria-label={ariaLabel}
            title={ariaLabel}
          >
            <Icon fontSize="small" />
          </button>
        ))}
      </div>
    </div>
  );
}
